export default __webpack_public_path__ + "static/media/Logo2.44245e44.webp";